/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.GiftCardIntegration {
  "use strict";

  export class GiftCardIntegrationContext extends Meevo.Components.CommonClasses.CommonContextBase {

      constructor(appSettings: Meevo.Components.Common.IAppSettings,
                  dataService: Meevo.Components.CommonClasses.ICommonDataService,
                  modalService: Meevo.Components.Modal.IModalService,
                  identityService: Meevo.Components.Common.IIdentityService,
                  loggingService: Meevo.Components.Logging.ILoggingService,
                  securityChecker: Meevo.Components.Common.ISecurityService,
                  private $translate: angular.translate.ITranslateService ) {
          super(appSettings, dataService, modalService, identityService, loggingService, securityChecker);

          this.todayDate = moment().startOf("day").toDate();
          // initialize end points
          this.baseEndpoint = appSettings.API_ENDPOINTS.giftCardIntegration;
          // initialize templatepaths
          this.sectionTemplatePath = "app/plugins/giftCardIntegration/sectionViews/";
          this.initializeSections();
          this.buildCrudSecurityKeysBase(this.securityKeys.DATA_GIFTCARDINTEGRATION_TAB_MAIN);
      }

    initializeSections(): void {
      // Adding sections items that represent areas in the maintenance form
      if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_GIFTCARDINTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
        this.sections.push(new MainSection(0, "SECTION_GIFTCARDINTEGRATION_MAIN", "main.html", true, false,
            this.baseEndpoint, "", this.loggingService, this.dataService, null, this.identityService, this.modalService, this.securityKeys.DATA_GIFTCARDINTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
      this.activate();
    }

      selectSection(item): void {

        super.selectSection(item);
      }


      initializeHeader(model: any): void {
        this.headerContent = this.$translate.instant("SECTION_GIFTCARDINTEGRATION_MAIN_HEADER");
    }

    public isCOMode = this.isApplicationModeCO();
  
    scheduledNotifications() {
        return null;
      //// create grouping for scheduled notifications
      //  let oBookSettingsModel = <Meevo.Model.OnlineBookingSettings>this.selectedSection.model;
      //  return oBookSettingsModel !== undefined
      //      && oBookSettingsModel.communicationTypeNotifications !== undefined
      //      ? oBookSettingsModel.communicationTypeNotifications.filter(i =>
      //    (i.communicationType === Model.CommunicationTypeEnum.AppointmentConfirmation ||
      //              i.communicationType === Model.CommunicationTypeEnum.AppointmentReminderDaysBefore))
      //  : null;
    }

  }
}